import { s3AdapterApi } from "@shared/api";

const OBJECT_TYPES = ["OBJECT", "object"] as const;

/** GET /s3-adapter/api/v1/files/{fileId}?type=OBJECT — бинарник файла */
export async function fetchS3FileBlob(fileId: string): Promise<Blob> {
  let lastError: unknown;

  for (const type of OBJECT_TYPES) {
    try {
      // eslint-disable-next-line no-await-in-loop
      const response = await s3AdapterApi.get(`files/${fileId}`, {
        params: { type },
        responseType: "blob",
      });

      if (response.data instanceof Blob && response.data.size > 0) {
        return response.data;
      }
    } catch (error) {
      lastError = error;
    }
  }

  if (lastError) {
    throw lastError;
  }

  throw new Error("Не удалось загрузить документ");
}
